module.exports = __webpack_public_path__ + "img/104.8c55f1eb.png";